<template>
  <div class="mt-3">
    <TopSection :title="$t('funds') | capitalize">
      <template v-slot:actions>
        <div class="flex items-center ml-4">
          <div class="d-flex align-items-center mr-4">
            <toggle-button
              v-model="showHiddenFundFiles"
              color="#2ec775"
            />
            <div class="ml-2">
              {{ $t('show_hidden') | capitalize }}
            </div>
          </div>
          <b-button
            v-b-modal.dropzoneModal
            size="lg"
            class="ml-4 px-4 py-2"
            variant="primary"
          >
            {{ $t('uploadFunds') | capitalize }}
          </b-button>
        </div>
      </template>
    </TopSection>

    <FundsFilesListTable :key="uploaded" :showHiddenFundFiles="showHiddenFundFiles" />

    <b-modal
      id="errorsModal"
      ref="errorsModal"
      hide-footer
      hide-header
      size="xl"
    >
      <div v-for="(errorType, i) in uploadErrors" :key="i">
        <div v-for="(error, j) in errorType" :key="j">
          <span class="medium-bold d-block">{{ error }}</span>
        </div>
      </div>
    </b-modal>

    <!-- Drop Zone -->
    <b-modal
      id="dropzoneModal"
      ref="dropzoneModal"
      hide-footer
      size="xl"
      @show="onShowModal"
    >
      <Dropzone
        ref="dropzone"
        type="funds"
        :title="$t('uploadFunds')"
        download-url="/templates/funds_template_v1_1.xlsx"
        upload-url="funds/upload/"
        @closeModal="closeModal"
        @error="onDropzoneError"
        @success="onDropzoneSuccess"
      />
    </b-modal>
  </div>
</template>


<script>
import FundsFilesListTable from "@/components/Modules/FundsFilesListTable"
import { mapMutations } from "vuex"

export default {
  name: "FundsPage",
  components: {
    FundsFilesListTable
  },

  data () {
    return {
      showHiddenFundFiles: false,
      uploadErrors: [],
      uploaded: 0
    }
  },

  created () {
    this.setStatusFilter(null)
    this.setUseTypeFilter(null)
  },

  methods: {
    onShowModal () {
      setTimeout(() => this.$refs.dropzone.$refs.myVueDropzone.removeAllFiles(true), 100)
    },
    closeModal () {
      this.$refs.dropzoneModal.hide()
    },
    onDropzoneSuccess () {
      this.uploaded = this.uploaded + 1
    },
    onDropzoneError (errors) {
      this.uploadErrors = errors
      this.$refs.errorsModal.show()
    },
    ...mapMutations("ui", ["setStatusFilter", "setUseTypeFilter"])
  },
}
</script>
